import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientArticulatedGoalsResponse } from "@/core/types";

import { getArticulatedGoals } from "../queryFunctions/getArticulatedGoals";
import { memberCarePlanKeys } from "../keyFactory";

type UseArticulatedGoalsProps<TData = PatientArticulatedGoalsResponse> = {
  patientId: string;
  select?: (data: PatientArticulatedGoalsResponse) => TData;
};

type ArticulatedGoalsQueryOptions = UseQueryOptions<
  PatientArticulatedGoalsResponse,
  unknown,
  PatientArticulatedGoalsResponse,
  ReturnType<typeof memberCarePlanKeys.articulatedGoals>
>;

export function useArticulatedGoals<TData = PatientArticulatedGoalsResponse>({
  patientId,
  select,
}: UseArticulatedGoalsProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

export function optionFactory(patientId: string) {
  return {
    queryFn: () => getArticulatedGoals(patientId),
    queryKey: memberCarePlanKeys.articulatedGoals(patientId),
  } satisfies ArticulatedGoalsQueryOptions;
}
